import type { FormFieldControlSlotProps } from "./types-control";
import { useFormFieldControl } from "./use-control";
import { FormFieldControlView } from "./view-control";

export function FormFieldControl(props: FormFieldControlSlotProps) {
  const viewModel = useFormFieldControl(props);

  return <FormFieldControlView {...viewModel} />;
}
FormFieldControl.displayName = "FormField.Control";
